import React, { useEffect } from 'react';
import { useCart } from '../Contexts/CartContext';
import { Link, useNavigate } from 'react-router-dom';
import './CheckoutPage.css';

const CheckoutPage = () => {
  const { cartItems, cartTotal } = useCart();
  const navigate = useNavigate();

  // Redirect to the shop if the cart is empty
  useEffect(() => {
    if (cartItems.length === 0) {
      navigate('/shop');
    }
  }, [cartItems, navigate]);

  // Don't render if cart is empty (prevents flicker before redirect)
  if (cartItems.length === 0) {
    return null;
  }

  return (
    <div className="checkout-container">
      <div className="checkout-content">
        <h1 className="checkout-title">Checkout</h1>
        <div className="checkout-grid">
          
          {/* Order Summary Section (still included) */}
          <div className="order-summary">
            <h2>Order Summary</h2>
            {cartItems.map(item => (
              <div key={item.cartItemId} className="summary-item">
                <span className="summary-item-name">{item.name} (x{item.quantity})</span>
                <span className="summary-item-price">${(item.price * item.quantity).toFixed(2)}</span>
              </div>
            ))}
            <div className="summary-total">
              <strong>Total</strong>
              <strong>${cartTotal.toFixed(2)}</strong>
            </div>
          </div>

          {/* Placeholder Section (replaces the form) */}
          <div className="shipping-details">
            <h2>Next Steps 🚧</h2>
            <p>
              Online payment processing is coming soon!
            </p>
            <p>
              To complete your order, please get in touch with us through our contact page. Be sure to mention the items in your order summary.
            </p>
            <Link to="/contact">
              <button className="place-order-button">Contact Us to Complete Order</button>
            </Link>
          </div>
        </div>
        <Link to="/shop" className="back-to-shop-link">← Back to Shop</Link>
      </div>
    </div>
  );
};

export default CheckoutPage;